<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="header">Salary and Fund Values</div>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label>Current Value of Living Annuity</label>
          <div class="ui labeled input">
            <currency-input
              v-model="laInputsDto.balance"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label
            >Required Income
            <small
              >(R
              {{
                formatNr(laInputsDto.getIncomeCashFlowRequests[0].income / 12)
              }}
              pm)</small
            ></label
          >
          <div class="ui labeled input">
            <currency-input
              v-model="laInputsDto.getIncomeCashFlowRequests[0].income"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label>Start year </label>
          <div class="ui labeled input">
            <input
              v-model="laInputsDto.getIncomeCashFlowRequests[0].startYear"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label> Income Growth (%) </label>
          <div class="ui labeled input">
            <input
              v-model="laInputsDto.getIncomeCashFlowRequests[0].incomeGrowth"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label> Income to last until age </label>
          <div class="ui labeled input">
            <input
              v-model="laInputsDto.getIncomeCashFlowRequests[0].incomeToLast"
              v-on:change="handleSelected"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="ui attached message">
      <div class="header">Spending Strategies</div>
    </div>
    <div class="ui attached segment">
      <div class="ui attached message">
        <strong>Guard Rails </strong>
        <div
          class="ui mini toggle checkbox"
          style="float: right !important; font-size: 10px"
        >
          <input
            type="checkbox"
            @change="handleSelected"
            v-model="laInputsDto.enableGuardRails"
          />
          <label>{{
            laInputsDto.enableGuardRails ? "Enabled" : "Disabled"
          }}</label>
        </div>
      </div>
      <div class="ui attached segment" v-if="laInputsDto.enableGuardRails">
        <div class="ui form">
          <div class="ui field">
            <label> Floor (%)</label>
            <div class="ui labeled input">
              <input
                v-model="laInputsDto.guardRailsRule.lowerPercentage"
                v-on:change="handleSelected"
              />
            </div>
          </div>
          <div class="ui field">
            <label> Ceiling (%)</label>
            <div class="ui labeled input">
              <input
                v-model="laInputsDto.guardRailsRule.upperPercentage"
                v-on:change="handleSelected"
              />
            </div>
          </div>
          <div class="ui field">
            <label> Apply until age</label>
            <div class="ui labeled input">
              <input
                v-model="laInputsDto.guardRailsRule.applyUntilAge"
                v-on:change="handleSelected"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="ui attached message">
        <strong>Freeze income </strong>
        <div
          class="ui mini toggle checkbox"
          style="float: right !important; font-size: 10px"
        >
          <input
            type="checkbox"
            @change="handleSelected"
            v-model="laInputsDto.enableFreezeCashflow"
          />
          <label>{{
            laInputsDto.enableFreezeCashflow ? "Enabled" : "Disabled"
          }}</label>
        </div>
      </div>

      <div class="ui attached message">
        <strong>Capital Preservation Rule </strong>
        <div
          class="ui mini toggle checkbox"
          style="float: right !important;font-size: 10px"
        >
          <input
            type="checkbox"
            @change="handleSelected"
            v-model="laInputsDto.enableCapitalPreservationRule"
          />
          <label>{{
            laInputsDto.enableCapitalPreservationRule ? "Enabled" : "Disabled"
          }}</label>
        </div>
      </div>
      <div
        class="ui attached segment"
        v-if="laInputsDto.enableCapitalPreservationRule"
      >
        <div class="ui form">
          <div class="ui field">
            <label> Cut Spending By (%) </label>
            <div class="ui labeled input">
              <input
                v-model="laInputsDto.capitalPreservationRule.spendingCut"
                v-on:change="handleSelected"
              />
            </div>
          </div>
          <div class="ui field">
            <label> if Withdrawal Rate rises by (%) </label>
            <div class="ui labeled input">
              <input
                style="font-size: small"
                v-model="
                  laInputsDto.capitalPreservationRule.withdrawalRisesByMoreThan
                "
                v-on:change="handleSelected"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="ui attached message">
        <strong>Prosperity Rule </strong>
        <div
          class="ui mini toggle checkbox"
          style="float: right !important; font-size: 10px"
        >
          <input
            type="checkbox"
            @change="handleSelected"
            v-model="laInputsDto.enableProsperityRule"
          />
          <label>{{
            laInputsDto.enableProsperityRule ? "Enabled" : "Disabled"
          }}</label>
        </div>
      </div>
      <div class="ui attached segment" v-if="laInputsDto.enableProsperityRule">
        <div class="ui form">
          <div class="ui field">
            <label> Increase Spending By (%) </label>
            <div class="ui labeled input">
              <input
                v-model="laInputsDto.capitalProsperityRule.spendingIncrease"
                v-on:change="handleSelected"
              />
            </div>
          </div>
          <div class="ui field">
            <label> if withdrawal rate falls by (%) </label>
            <div class="ui labeled input">
              <input
                v-model="
                  laInputsDto.capitalProsperityRule.withdrawalRateFallsBy
                "
                v-on:change="handleSelected"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
export default {
  name: "Testing",
  props: ["laInputsDto"],
  data() {
    return {
      showBonusStrategy: false,
    };
  },
  computed: {
    partnerId() {
      return this.$store.state.partnerId;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0a");
    },
    async handleSelected(selected) {
      this.$emit("handleWrapperInputsChanged", {
        laInputsDto: this.laInputsDto,
      });
    },

    async init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}

.highlight {
  font-weight: bold;
}
</style>
